const dev = {
  SENSOR_HOST: "https://data.cgws.com/sa_statistics/sa?project=default",
  ACT_NAME: "金哥挖宝20200415",
  PAGE_NAME: "Act_jgbx_20200415",
  PLATFORM: "h5",
  IOS_DOWNLOAD_OR_OPEN_APP:
    "https://devfintech.cgws.com:8443/oss-guidance/index.html?type=h5&url=https://devfintech.cgws.com:8443/dig-treasure/",
  WECHAT_HOST: "https://wx-test.cgws.com",
  ACTIVITY_CODE: "treasure-box-20200415",
  title: "金哥宝箱，助您战“疫”",
  content: "累计四周，周周壕礼，金哥宝箱邀您来战。",
  imageUrl:
    "https://fintechapp-prd-1258285289.cos.ap-guangzhou.myqcloud.com/ops/2020-04/1585710740851-2be1fffce7d7482dbbf9dd33aac62a2c.png",
  httpUrl: "https://devfintech.cgws.com:8443/dig-treasure/",
}

const stag = {
  SENSOR_HOST: "https://data.cgws.com/sa_statistics/sa?project=default",
  ACT_NAME: "金哥挖宝20200415",
  PAGE_NAME: "Act_jgbx_20200415",
  PLATFORM: "h5",
  IOS_DOWNLOAD_OR_OPEN_APP:
    "https://stgfintech.cgws.com:8443/oss-guidance/index.html?type=h5&url=https://stgfintech.cgws.com:8443/dig-treasure/",
  WECHAT_HOST: "https://wx-test.cgws.com",
  ACTIVITY_CODE: "treasure-box-20200415",
  title: "金哥宝箱，助您战“疫”",
  content: "累计四周，周周壕礼，金哥宝箱邀您来战。",
  imageUrl:
    "https://fintechapp-prd-1258285289.cos.ap-guangzhou.myqcloud.com/ops/2020-04/1585710740851-2be1fffce7d7482dbbf9dd33aac62a2c.png",
  httpUrl: "https://stgfintech.cgws.com:8443/dig-treasure/",
}

const prod = {
  SENSOR_HOST: "https://data.cgws.com/sa_statistics/sa?project=production",
  ACT_NAME: "金哥挖宝20200415",
  PAGE_NAME: "Act_jgbx_20200415",
  PLATFORM: "h5",
  IOS_DOWNLOAD_OR_OPEN_APP:
    "https://fintechapp.cgws.com/oss-guidance/index.html?type=h5&url=https://fintechapp.cgws.com/dig-treasure/",
  WECHAT_HOST: "https://t.cgws.com",
  ACTIVITY_CODE: "treasure-box-20200415",
  title: "金哥宝箱，助您战“疫”",
  content: "累计四周，周周壕礼，金哥宝箱邀您来战。",
  imageUrl:
    "https://fintechapp-prd-1258285289.cos.ap-guangzhou.myqcloud.com/ops/2020-04/1585710740851-2be1fffce7d7482dbbf9dd33aac62a2c.png",
  httpUrl: "https://fintechapp.cgws.com/dig-treasure/",
}

const config =
  process.env.REACT_APP_NODE_ENV === "production"
    ? prod
    : process.env.REACT_APP_NODE_ENV === "staging"
    ? stag
    : dev

export default {
  ...config,
}
